module.exports = __webpack_public_path__ + "img/laptop-small.16d085a7.svg";